// removed by extract-text-webpack-plugin
module.exports = {"space":"hk-space-space"};